"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * Noop.
 *
 * @return {Void}
 */

function noop() {}

/**
 * Export.
 *
 * @type {Function}
 */

exports.default = noop;


//////////////////
// WEBPACK FOOTER
// ../node_modules/slate-react/lib/utils/noop.js
// module id = 1289
// module chunks = 0